import { z } from 'zod/v3';
import { EntitySchema } from '../../common/utils/schema/EntitySchema';
import { createPaginationSchema } from '../../common/utils/schema';
import { errorMap, zDescription, zName } from '../../common/utils';
import translations from './AccessGroupSchema.translations.json';
import { i18nNsFactory } from '@atlas-frontend/i18n';

const { addTranslations, t } = i18nNsFactory('access-group-schema');
addTranslations(translations);

export const AccessGroupSchema = EntitySchema.extend({
  id: z.number(),
  name: z.string(),
  description: z.string().nullable(),
});

export const AccessGroupListSchema = AccessGroupSchema.extend({
  roles: z.string().nullable(),
});

export const AccessGroupPageSchema = createPaginationSchema(
  AccessGroupListSchema,
);

export const AccessGroupValidFormDataSchema = z.object({
  name: zName(errorMap(() => t('validation.name.required'))).min(1),
  description: zDescription().nullable(),
});

export const AccessGroupOptionSchema = AccessGroupSchema.transform((item) => ({
  value: item.name,
  label: item.name,
  item: item,
}));

export const AccessGroupOptionsPageSchema = createPaginationSchema(
  AccessGroupOptionSchema,
);
